import {Component, EventEmitter, OnInit, Input, Output, AfterViewInit} from '@angular/core';
import {FormInputBase} from '../ng-material-form/model';
import {Subject} from 'rxjs';
import {FormParams} from '../../models/child-params.model';
import {NgMaterialFormService} from '../ng-material-form/service/ng-material-form.service';
import {PageStateService} from '../../services/page-state.service';

@Component({
  selector: 'ngx-ng-material-filter',
  templateUrl: './ng-material-filter.component.html',
  styleUrls: ['./ng-material-filter.component.scss'],
})
export class NgMaterialFilterComponent implements OnInit, AfterViewInit {
  // Form
  @Input() filterForm: FormInputBase<string | boolean>[] | null = [];
  @Output('sentFilterToParent') sentFilterToParent: EventEmitter<any> = new EventEmitter();
  formRender: boolean = false;
  submitFilterForm: Subject<any> = new Subject();

  filter: Partial<any> = {};
  // Spinner
  loadSpinner: boolean = false;
  formParams: FormParams = new FormParams();

  constructor(private ngMaterialFormService: NgMaterialFormService, private pageStateService: PageStateService) {}

  ngOnInit(): void {
    this.formRender = true;
  }

  ngAfterViewInit(): void {
    if (this.formRender) {
      // Call your function when the form is rendered
      this.onSubmit();
    }
  }

  onSubmit() {
    // GetForm From child
    this.formParams.type = 'Save';
    this.submitFilterForm.next(this.formParams);
  }

  onReset() {
    this.formParams.type = 'reset';
    this.submitFilterForm.next(this.formParams);
    this.pageStateService.removeCurrentPageStateFromLocalStorage();
  }

  listenFilterForm(res) {
    if (res && res.res) {
      this.filter = Object.assign({}, this.filter, res.res);

      // if date null
      if (!this.filter.date) {
        this.filter.date = this.ngMaterialFormService.getDefault();
      }

      this.filter.type = res.type;
      this.filter.membershipId = res.membershipId;
      this.sentFilterToParent.emit(this.filter);
    }
  }
}
